const sortByListSortAttribute  = seasonPassList => {
  const sortedSeasonPassList = seasonPassList.sort((pass1, pass2) => {
    const sortValue1 = pass1.attributes?.publicData?.listSort;
    const sortValue2 = pass2.attributes?.publicData?.listSort;

    return sortValue1 - sortValue2;
  });

  return sortedSeasonPassList;
};

export { sortByListSortAttribute  };
